export default "__VITE_ASSET__1d818bf2__"